import React, { Component } from "react";
import Proptypes from "prop-types";
import ReactJson from 'react-json-view';
import iconNo from "../../../../../assets/images/icon_no.svg";
import iconYes from "../../../../../assets/images/icon_yes.svg";

export default class ViewAzureVmProviderConfig extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        const { currentVmProviderConfig } = this.props;
        return (
            <React.Fragment>
                <tr><td><h4>Name</h4></td><td>{currentVmProviderConfig.config_name || "-"}</td></tr>
                <tr><td><h4>Subscription ID</h4></td><td>{currentVmProviderConfig.azure_subscription_id}</td></tr>
                <tr><td><h4>Resource Group</h4></td><td>{currentVmProviderConfig.azure_resource_group}</td></tr>
                <tr><td><h4>Tenant ID</h4></td><td><span>{currentVmProviderConfig.azure_tenant_id}</span></td></tr>
                <tr><td><h4>Client ID</h4></td><td>{currentVmProviderConfig.azure_client_id}</td></tr>
                <tr><td><h4>Client Secret</h4></td><td>{currentVmProviderConfig.azure_client_secret}</td></tr>
                <tr><td><h4>Azure Authority</h4></td><td>{currentVmProviderConfig.azure_authority}</td></tr>
                <tr><td><h4>Region</h4></td><td>{currentVmProviderConfig.azure_region}</td></tr>
                <tr><td><h4>Max Instances</h4></td><td>{currentVmProviderConfig.azure_max_instances}</td></tr>
                <tr><td><h4>VM Size</h4></td><td>{currentVmProviderConfig.azure_vm_size}</td></tr>
                <tr><td><h4>OS Disk Type</h4></td><td>{currentVmProviderConfig.azure_os_disk_type}</td></tr>
                <tr><td><h4>OS Disk Size (GB)</h4></td><td>{currentVmProviderConfig.azure_os_disk_size_gb}</td></tr>
                <tr><td><h4>OS Image Reference (JSON)</h4></td><td>
                    <ReactJson src={currentVmProviderConfig.azure_image_reference}
                        name={false}
                        collapsed={false}
                        sortKeys={true}
                        collapseStringsAfterLength={40}
                        enableClipboard={false}
                        displayDataTypes={false}
                    />
                </td></tr>
                <tr><td><h4>Network Security Group</h4></td><td>{currentVmProviderConfig.azure_network_sg}</td></tr>
                <tr><td><h4>Subnet</h4></td><td>{currentVmProviderConfig.azure_subnet}</td></tr>
                <tr><td><h4>Assign Public IP</h4></td><td><img src={currentVmProviderConfig.azure_public_ip ? iconYes : iconNo} alt="yesnoIcon" /></td></tr>
                <tr><td><h4>Tags (JSON)</h4></td><td>
                    <ReactJson src={currentVmProviderConfig.azure_tags}
                        name={false}
                        collapsed={false}
                        sortKeys={true}
                        collapseStringsAfterLength={40}
                        enableClipboard={false}
                        displayDataTypes={false}
                    />
                </td></tr>
                <tr><td><h4>OS Username</h4></td><td>{currentVmProviderConfig.azure_os_username}</td></tr>
                <tr><td><h4>OS Password</h4></td><td><span>{currentVmProviderConfig.azure_os_password}</span></td></tr>
                <tr><td><h4>SSH Public Key</h4></td><td><span>{currentVmProviderConfig.azure_ssh_public_key}</span></td></tr>
                <tr><td><h4>Agent Startup Script</h4></td><td><span>{currentVmProviderConfig.azure_startup_script}</span></td></tr>
                <tr><td><h4>Config Override (JSON)</h4></td><td>
                    <ReactJson src={currentVmProviderConfig.azure_config_override}
                        name={false}
                        collapsed={false}
                        sortKeys={true}
                        collapseStringsAfterLength={40}
                        enableClipboard={false}
                        displayDataTypes={false}
                    />
                </td></tr>
            </React.Fragment>
        );
    }
}

ViewAzureVmProviderConfig.propTypes = {
    currentVmProviderConfig: Proptypes.object.isRequired,
};
